import { DataType, FilterOperator } from "../Enums";
import {
  AdvancedFilterCondition,
  CreateContainAdvancedFilterCondition,
  CreateEqualAdvancedFilterCondition,
} from "../models/advanced-search/AdvancedFilterCondition";
import { AdvancedSearchFilterItem } from "../models/advanced-search/AdvancedSearchFilterItem";
import { DateTimeHelper } from "./DateTime.helper";
import { Utils } from "./Utils";

export class AdvancedQueryHelper {
  static GenerateFilterConditions(filterParams: any): AdvancedFilterCondition[] {
    const conditions: AdvancedFilterCondition[] = [];

    for (const key in filterParams) {
      if (filterParams.hasOwnProperty(key)) {
        const value = filterParams[key];

        if (Array.isArray(value) && value.length > 0) {
          conditions.push(CreateContainAdvancedFilterCondition(key, value));
        }

        if (!Array.isArray(value) && value !== null && value !== undefined && value !== "") {
          conditions.push(CreateEqualAdvancedFilterCondition(key, value));
        }
      }
    }

    return conditions;
  }

  static GenerateFromAdvancedQuery(filterParams: AdvancedSearchFilterItem[]) {
    const conditions: AdvancedFilterCondition[] = [];
    if (!filterParams || filterParams.length === 0) {
      return conditions;
    }

    filterParams.forEach((filter) => {
      if (filter.field === "" || filter.operator === "" || filter.value === "") {
        return;
      }

      const condition = new AdvancedFilterCondition();
      condition.propertyName = filter.field;
      condition.operator = parseInt(filter.operator);

      if (condition.operator === FilterOperator.In || condition.operator === FilterOperator.NotIn) {
        condition.values = filter.value.split(",").map((v) => v.trim());
      } else {
        condition.value = filter.value;
        if (filter.type === DataType.Date && !Utils.isEmpty(filter.value)) {
          if (condition.operator === FilterOperator.LessThan) {
            condition.value = DateTimeHelper.LocalToStartUTCString(condition.value);
          } else if (condition.operator === FilterOperator.GreaterThan) {
            condition.value = DateTimeHelper.LocalToEndUTCString(condition.value);
          }
        }
      }

      conditions.push(condition);
    });

    return conditions;
  }
}
